<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">     
      
      <el-form :inline="true" class="backborder1 demo-form-inline" ref="query" :model="query" size="small">
	  	  <!-- 发放方式 -->
		  <el-form-item style="width:12%">
			  <el-select v-model="query.type" clearable filterable @change="isselect=true">
				  <el-option v-for="(item,index) in typelists" :label="item.name" :value="item.id" :key="index"></el-option>
			  </el-select> 
		  </el-form-item>
		  <!-- 代金券类型 -->
		  <el-form-item style="width:12%">
			  <el-select v-model="query.couptype" clearable filterable @change="isselect=true">
				  <el-option v-for="(item,index) in couptypelists" :label="item.name" :value="item.id" :key="index"></el-option>
			  </el-select> 
		  </el-form-item>
		  <!-- 优惠类型 -->
		  <el-form-item style="width:12%">
			  <el-select v-model="query.discounttype" filterable clearable @change="isselect=true">
				  <el-option v-for="(item,index) in discounttypelists" :label="item.name" :value="item.id" :key="index"></el-option>
			  </el-select> 
		  </el-form-item>
		  <!-- 是否可以与活动同时使用 -->
		  <el-form-item style="width:12%">
			  <el-select v-model="query.isjoin" filterable clearable @change="isselect=true">
				  <el-option v-for="(item,index) in isjoinlists" :label="item.name" :value="item.id" :key="index"></el-option>
			  </el-select> 
		  </el-form-item>
		  <el-form-item style="width:17%">
			  <el-select v-model="query.keytype" filterable clearable @change="isselect=true">
				  <el-option v-for="(item,index) in keytypelists" :label="item.name" :value="item.id" :key="index"></el-option>
			  </el-select> 
		  </el-form-item>
          <el-form-item>
              <el-input clearable placeholder="优惠券名称 / 优惠券码" v-model="query.key" @change="isselect=true" @keyup.enter.native="getList"></el-input>
          </el-form-item>
          <el-form-item>
              <el-button type="primary" round icon="el-icon-search" @click="getList">查询</el-button>
              <el-button type="danger" round icon="el-icon-circle-plus-outline" @click="addcoupon">新增</el-button>
          </el-form-item>
      </el-form>
      
      <div class="backborder2" style="margin-top:10px">		  
		  <el-table :data="lists" style="width: 100%" v-loading="listLoading">	    		
		      <el-table-column label="名称" prop="discribe">
			  	  <template slot-scope="scope">
					  <div style="float:left;width:100%">
					  	<span style="float:left;margin-right:2%;font-size:13px">
						  {{scope.row.discribe}}
						  <i style="margin-left:5px;font-size:12px;color:#fff;background:#e6a23c;line-height:12px;border-radius:5px;padding:3px 5px;font-style:normal">{{scope.row.type}}</i>
						</span>
						<span style="float:left;width:100%;font-size:12px;color:#666666;line-height:12px;margin-top:10px">创建人员：{{scope.row.managername}}</span>
						<span style="float:left;width:100%;font-size:12px;color:#666666;line-height:12px;margin-top:10px">创建时间：{{scope.row.inputtime}}</span>
					  </div>
				  </template>
			  </el-table-column>
			  <el-table-column label="满足条件" align="left" width="260">
				  <template slot-scope="scope">
				  	<span style="float:left;width:100%;font-size:13px;line-height:13px">{{scope.row.couptype}}<i style="font-style:normal;color:red" v-if="scope.row.isjoin==1">（允许与活动一起使用）</i></span>
					<span style="float:left;width:100%;font-size:13px;line-height:13px;margin-top:10px">{{scope.row.discount}}</span>
				  </template>
			  </el-table-column>
		      <el-table-column label="有效时间" align="left" width="160">
			  	  <template slot-scope="scope">
					  <span style="font-size:13px">{{scope.row.expiretime}}</span>
				  </template>
			  </el-table-column>		      
		      <el-table-column label="操作" align="center" width="200">
		        	<template slot-scope="scope">
						<el-button type="warning" icon="el-icon-tickets" size="small" circle @click="showcoupondetail(scope.row)"></el-button>
						<!--
		        		<el-button type="primary" icon="el-icon-tickets" size="small" circle @click="showorder(scope.row)"></el-button>
		        		<el-button type="warning" icon="el-icon-edit" size="small" circle @click="editCurrent(scope.row)"></el-button>
						-->
						<el-button type="danger" size="small" icon="el-icon-delete" @click="delCurrent(scope.row)" circle></el-button>
						<el-button 
							:type="scope.row.can_be_deactivated == 0 ? 'info' : 'danger'" 
							:disabled="scope.row.can_be_deactivated == 0" 
							round  
							size="small"
							@click="stopCurrent(scope.row)" 
						>停用</el-button>
					</template>
		      </el-table-column>		      
	      </el-table>
	      <div class="block">
	          <!--分页begin-->
	          <el-pagination
		          @size-change="queryPageSizeChange"
		          @current-change="queryPageCurrentChange"
		          :current-page="query.p"
		          :page-sizes="[10, 20, 50]"
		          :page-size="query.rollpage"
		          layout="total, sizes, prev, pager, next, jumper"
		          :total="total_rows">
	          </el-pagination>
	          <!--分页end-->
	      </div>		      	  
      </div>
      
      <!----------新增代金券-------------->
      <el-dialog title="新增代金券" :visible.sync="couponDialog" width="70%" top="10vh" label-width="10">
      	  <el-form :inline="true" size="small">
			  <el-col :span="24">
			  	  <div style="float:left;width:100%;padding-bottom:.2rem;margin-bottom:1rem;margin-top:1rem;border-bottom:1px dashed rgb(221,221,221,.8)"><i style="font-style:normal;color:#fff;background:#E6A23C;padding:.2rem 1rem;border-radius:15px;font-size:.7rem">基础信息</i></div>
			  	  <el-col :span="24">
						<el-form-item label="领取途径" style="width:30%" label-width="110" class="coupercent">
							<el-select v-model="create.type" filterable @change="changecouptype('add')">
								<el-option v-for="(item,index) in typelists" :label="item.name" :value="item.id" :key="index"></el-option>
							</el-select> 
						</el-form-item>
						<el-form-item label="代金券名" style="width:30%">
							<el-input placeholder="请输入代金券名" v-model="create.name"></el-input>
						</el-form-item>
						<el-form-item label="编码规则" style="width:30%" v-if="create.type==1">
							<el-select v-model="create.value" filterable>
								<el-option v-for="(item,index) in valuelists" :label="item.name" :value="item.id" :key="index"></el-option>
							</el-select>
						</el-form-item>
						<el-form-item label="领取开始" style="width:30%" v-if="create.type==2">
							<el-date-picker v-model="create.scollecttime" type="datetime" placeholder="起始时间" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
						</el-form-item>
						<el-form-item label="领取结束" style="width:30%" v-if="create.type==2">
							<el-date-picker v-model="create.ecollecttime" type="datetime" placeholder="截至时间" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
						</el-form-item>
				  </el-col>
				  <el-col :span="24">
						<el-form-item label="发放数量" v-if="create.type==1 || create.type==2" style="width:30%">
							<el-input placeholder="发放数量" v-model="create.basenum"></el-input>
						</el-form-item>
						<el-form-item label="每人限领数量" v-if="create.type==2" style="width:30%">
							<el-input placeholder="每人限制领取数量" v-model="create.shop_limit"></el-input>
						</el-form-item>
						<el-form-item label="单次点击领取数量" v-if="create.type==2" style="width:33%">
							<el-input placeholder="单次点击领取数量" v-model="create.oncelimit"></el-input>
						</el-form-item>
				  </el-col>
				  <el-col :span="24">
						<el-form-item label="有效期类型" style="width:30%" label-width="110" class="coupercent" v-if="create.type==1 || create.type==2">
							<el-select v-model="create.expiretype" filterable @change="">
								<el-option v-for="(item,index) in expirelist" :label="item.name" :value="item.id" :key="index"></el-option>
							</el-select> 
						</el-form-item>
						<el-form-item label="起始时间" style="width:30%" v-if="create.expiretype==1">
							<el-date-picker v-model="create.starttime" type="datetime" placeholder="起始时间" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
						</el-form-item>
						<el-form-item label="截止时间" style="width:30%" v-if="create.expiretype==1">
							<el-date-picker v-model="create.exptime" type="datetime" placeholder="截止时间" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
						</el-form-item>
						<el-form-item label="指定天数" style="width:30%" v-if="create.expiretype==2">
							<el-input placeholder="天" v-model="create.expireday"></el-input>
						</el-form-item>
				  </el-col>
				  <el-col :span="24">
						<el-form-item label="代金券类型" style="width:30%" label-width="110" class="coupercent">
							<el-select v-model="create.couptype" filterable>
								<el-option v-for="(item,index) in couptypelists" :label="item.name" :value="item.id" :key="index"></el-option>
							</el-select> 
						</el-form-item>
						<el-form-item label="领取人群" style="width:30%" label-width="110" class="coupercent" v-if="create.type==2">
							<el-tooltip placement="top">
								<div slot="content">所有用户：所有宠老板用户<br/>新用户：没有在商城采购过商品的宠老板用户<br/>老用户：已在商城采购过商品的宠老板用户<span v-if="create.couptype == 3"><br/>品牌新人：未与该品牌有过交易成功的用户</span></div>
									<el-select v-model="create.usetype" filterable>
										<el-option v-for="(item,index) in userTypeList" :label="item.name" :value="item.id" :key="index"></el-option>
									</el-select>
								</el-tooltip> 
						</el-form-item>
						<el-form-item label="备注" style="width:30%">
							<el-input type="textarea" placeholder="备注" v-model="create.note"></el-input>
						</el-form-item>
				  </el-col>
			  </el-col>

			  <el-col :span="24">
			  	  <div style="float:left;width:100%;padding-bottom:.2rem;margin-bottom:1rem;margin-top:1rem;border-bottom:1px dashed rgb(221,221,221,.8)"><i style="font-style:normal;color:#fff;background:#E6A23C;padding:.2rem 1rem;border-radius:15px;font-size:.7rem">优惠条件</i></div>
			  	  <el-form-item label="优惠类型" style="width:50%">
					  <el-select v-model="create.discounttype" filterable>
						  <el-option v-for="(item,index) in discounttypelists" :label="item.name" :value="item.id" :key="index"></el-option>
					  </el-select> 
				  </el-form-item>
				  <el-form-item label="与活动同时使用" style="width:46%" class="coupradio">
					  <el-radio-group v-model="create.isjoin">
						  <el-radio :label="0">否</el-radio>
						  <el-radio :label="1">是</el-radio>
					  </el-radio-group>
				  </el-form-item>
				  <el-form-item label="满足金额" style="width:47%" v-if="create.discounttype==1">
	              	  <el-input placeholder="满足金额" v-model="create.usecondition1"></el-input>
				  </el-form-item>
				  <el-form-item label="减少金额" style="width:45%" v-if="create.discounttype==1">
					  <el-input placeholder="减少金额" v-model="create.edu1"></el-input>
				  </el-form-item>
				  <el-form-item label="满足金额" style="width:47%" v-if="create.discounttype==2">
	              	  <el-input placeholder="满足金额" v-model="create.usecondition2"></el-input>
				  </el-form-item>
				  <el-form-item label="折扣（100%）" style="width:45%" label-width="110" v-if="create.discounttype==2" class="coupercent">
					  <el-input placeholder="折扣" v-model="create.edu2"></el-input>
				  </el-form-item>
				  <el-form-item label="满足数量" style="width:47%" v-if="create.discounttype==3">
	              	  <el-input placeholder="满足数量" v-model="create.usecondition3"></el-input>
				  </el-form-item>
				  <el-form-item label="折扣（100%）" style="width:45%" label-width="110" v-if="create.discounttype==3" class="coupercent">
					  <el-input placeholder="折扣" v-model="create.edu3"></el-input>
				  </el-form-item>
			  </el-col>

			  <!-- 优惠券指定品牌/商品 -->
			  <el-col :span="24" v-if="create.couptype > 1">
			  	  <div style="float:left;width:100%;padding-bottom:.2rem;margin-bottom:1rem;margin-top:1rem;border-bottom:1px dashed rgb(221,221,221,.8)"><i style="font-style:normal;color:#fff;background:#E6A23C;padding:.2rem 1rem;border-radius:15px;font-size:.7rem">品牌/商品信息</i></div>
				  <el-button type="danger" icon="el-icon-plus" size="mini" circle style="float:right;margin-top:-3.2rem" @click="getgoodsorbrand('add')"></el-button>
			  </el-col>
			  <div style="float:left;margin-bottom:.5rem;width:96%;padding:.5rem 2%;border-radius:5px" v-if="create.couptype > 0">
				  
				  <div v-for="(item,index) in create.idsinfo" :key="index" style="float:left;width:calc(100% - 40px);height:80px;padding:0 20px;border-bottom:1px dashed rgb(221,221,221,.7);padding:.8rem 0;">
				  	  <div style="float:left;width:70%;height:80px">
						  <div style="float:left;width:60px;height:60px;border:1px solid rgba(221,221,221,.7);background:rgba(221,221,221,.3);border-radius:6px;margin-top:18px;display:flex;justify-content:center;align-items:center;">
						  	  <img :src="item.thumb"  style="max-width:85%;max-height:85%;border-radius:6px;"/>
						  </div>
						  <div style="float:left;width:calc(100% - 60px - 2px - 10px);height:60px;margin-left:10px;margin-top:18px;font-size:13px;line-height:21px;">
						  	  {{item.name}}
						  </div>
					  </div>
					  <div style="float:left;width:30%;height:80px;display:flex;justify-content:center;align-items:center;">
					  	  <el-button type="danger" icon="el-icon-delete" size="mini" circle @click="degoodsorbrand('add',index)"></el-button>
					  </div>
				  </div>
				  
				  <!--
				  <el-col :span="24" v-for="(item,index) in create.idsinfo" :key="index" style="border-bottom:1px dashed rgb(221,221,221,.7);padding:.8rem 0">
					  <el-col :span="2"><img :src="item.thumb" style="float:left;border:1px solid rgb(221,221,221,.7);border-radius:5px;width:100%"/></el-col>
					  <el-col :span="17" style="padding-left:2%">{{item.name}}</el-col>
					  <el-col :span="4" style="text-align:right"><el-button type="danger" icon="el-icon-delete" size="mini" circle @click="degoodsorbrand('add',index)"></el-button></el-col>
				  </el-col>
				  -->
			  </div>

			  <!-- 优惠券指定店员 -->
			  <el-col :span="24" v-if="create.type==3">
			  	  <div style="float:left;width:100%;padding-bottom:.2rem;margin-bottom:1rem;margin-top:1rem;border-bottom:1px dashed rgb(221,221,221,.8)"><i style="font-style:normal;color:#fff;background:#E6A23C;padding:.2rem 1rem;border-radius:15px;font-size:.7rem">指定店员发放数量</i></div>
				  <el-button type="danger" icon="el-icon-plus" size="mini" circle style="float:right;margin-top:-3.2rem" @click="getshops('add')"></el-button>
			  </el-col>
			  <div style="float:left;margin-bottom:.5rem;width:96%;padding:.5rem 2%;border-radius:5px" v-if="create.type==3">
				  <el-col :span="24" v-for="(item,index) in create.shops" :key="index" style="border-bottom:1px dashed rgb(221,221,221,.7);padding:.8rem 0">
					  <el-col :span="18" style="padding-left:2%;font-weight:340;">{{item.username}}（所属店铺：{{item.shopname}}）</el-col>
					  <el-col :span="2" style="padding-left:2%"><el-input placeholder="发放数量" v-model="item.num" size="mini"></el-input></el-col>
					  <el-col :span="4" style="text-align:right"><el-button type="danger" icon="el-icon-delete" size="mini" circle @click="deshops('add',index)"></el-button></el-col>
				  </el-col>
			  </div>

      	  </el-form>
      	  <div class="block" style="text-align:right">
      	  	  <el-button @click="couponDialog=false" size="small">取消</el-button>
	          <el-button type="primary" :loading="createLoading" @click="createsave" size="small">保存</el-button>
      	  </div>
      </el-dialog>

	  <!-- 选择商品供应商类型 -->
	  <el-dialog title="选择供应商类型" :visible.sync="applytypeDialog" width="25%" top="10vh" label-width="10">
		  <el-table :data="ismoreapplylists" style="width: 100%" v-loading="applytypeLoading">	    		
		      <el-table-column label="名称" prop="name"></el-table-column>		      
		      <el-table-column label="操作" align="center" width="110">
		        	<template slot-scope="scope">
						<el-button type="success" size="mini" icon="el-icon-check" @click="selectapply(scope.row)" circle></el-button>
					</template>
		      </el-table-column>		      
	      </el-table>
	  </el-dialog>

      
      <!----------编辑代金券-------------->
      <el-dialog title="编辑代金券" :visible.sync="editcouponDialog" width="50%" top="10vh" label-width="10">
      	  <el-form :inline="true" size="small">
      	  	  <el-form-item label="代金券名" style="width:45%">
	              <el-input placeholder="请输入代金券名" v-model="update.name"></el-input>
	          </el-form-item>
	          <el-form-item label="满足条件">
	              <el-input placeholder="满足条件" v-model="update.usecondition"></el-input>
	          </el-form-item>
	          <el-form-item label="减免条件" style="width:45%">
	              <el-input placeholder="减免条件" v-model="update.edu"></el-input>
	          </el-form-item>
	      	  <el-form-item label="截止时间">
	              <el-date-picker v-model="update.exptime" type="datetime" placeholder="截止时间" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
	          </el-form-item>
	          <el-form-item label="发放数量" style="width:45%" v-if="update.type!=3">
	              <el-input placeholder="发放数量" v-model="update.basenum"></el-input>
	          </el-form-item>
			  <!--
			  <el-form-item label="适用产品类型" v-if="ismoreapplyaccess==true" style="width:100%">
			  	  <el-button type="primary" size="mini" style="float:left" @click="getapplyproducts('update')">选择商品类型</el-button>
				  <el-tag type="danger" size="mini" style="float:left;margin:.4rem 0 0 .8rem ">温馨提示：不选择视为适用于全部商品</el-tag>
			  	  <div style="float:left;width:100%;margin:1rem 0 0 0;">
				  	  <el-tag type="success" style="float:left;margin:0 .8rem .8rem 0" v-for="(item,index) in this.update.applyproduct" closable @close="delapply(index,'update')" :key="index">{{item.name}}</el-tag>
				  </div>
			  </el-form-item>
			  -->
      	  </el-form>
      	  <div class="block" style="text-align:right">
      	  	  <el-button @click="editcouponDialog=false" size="small">取消</el-button>
	          <el-button type="primary" :loading="updateLoading" @click="updatesave" size="small">保存</el-button>
      	  </div>
      </el-dialog>
      
      <!------------ 代金券列表 ----------------->
      <el-dialog :title="detail.name" :visible.sync="detailDialog" width="55%" top="5vh">
      	  <el-form :inline="true" size="small">
      	  	  <el-form-item>
	              <el-input placeholder="请输入代金券编码" v-model="detail.key"></el-input>
	          </el-form-item>
	          <el-form-item>
	              <el-button type="primary" @click="getdetail" size="small" @change="detailisselect=true">查询</el-button>
	          </el-form-item>
      	  </el-form>
      	  <el-table :data="detaillists" style="width: 100%" v-loading="detailLoading">	    		
		      <el-table-column label="代金券编码" prop="code"></el-table-column>
		      <el-table-column label="是否领取" align="left" width="200">
		      	  <template slot-scope="scope">
					  <span style="font-size:.7rem;" v-if="scope.row.status==0">未领取</span>
					  <span style="font-size:.7rem;" v-if="scope.row.status==1">已领取</span>
					  <span style="float:left;width:100%;font-size:.7rem" v-if="scope.row.usershop!='' && scope.row.usershop!=null">领取店铺：{{scope.row.usershop}}</span>
		      	  </template>
		      </el-table-column>
			  <el-table-column label="是否使用" align="left" width="200">
		      	  <template slot-scope="scope">
					  <span style="font-size:.7rem;" v-if="scope.row.usercoupon=='未使用'">未使用</span>
					  <span style="font-size:.7rem;" v-if="scope.row.usercoupon=='已使用'">已使用</span>
					  <span style="float:left;width:100%;font-size:.7rem" v-if="scope.row.userorder!='' && scope.row.usershop!=null">订单号：{{scope.row.userorder}}</span>
		      	  </template>
		      </el-table-column>		      
		      <el-table-column label="操作" align="center" width="110">
		        	<template slot-scope="scope">
						<el-button type="danger" size="small" icon="el-icon-delete" @click="delDetail(scope.row)" circle v-if="scope.row.status==0"></el-button>
					</template>
		      </el-table-column>		      
	      </el-table>
	      <div class="block">
	          <!--分页begin-->
	          <el-pagination
		          @size-change="detailPageSizeChange"
		          @current-change="detailPageCurrentChange"
		          :current-page="query.p"
		          :page-sizes="[10, 20, 50]"
		          :page-size="query.rollpage"
		          layout="total, sizes, prev, pager, next, jumper"
		          :total="detail_total_rows">
	          </el-pagination>
	          <!--分页end-->
	      </div>
		  <div class="block" style="text-align:right;margin-top:20px">
      	  	  <el-button @click="couponDialog=false" size="small">取消</el-button>
      	  </div>      	  
      </el-dialog>

	  <!-- 获取品牌/商品信息列表 -->
	  <el-dialog title="获取品牌/商品信息列表" :visible.sync="goodsorbrandDialog" width="50%" top="5vh">
		  <el-form :inline="true" size="small">
      	  	  <el-form-item v-if="create.couptype > 1">
				  <el-select v-model="goodsorbrandquery.brandid" clearable remote  filterable placeholder="按品牌" @change="goodsorbrandchange=true">	            
					  <el-option v-for="(item,index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
						  <span style="float: left">{{item.name}}</span>
						  <span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
					  </el-option>              
              	  </el-select>  
	          </el-form-item>
			  <el-form-item>
			  	  <el-input placeholder="请输入关键字" v-model="goodsorbrandquery.key" @change="goodsorbrandchange=true" @keyup.enter.native="getgoodsorbranddata"></el-input>
			  </el-form-item>
	          <el-form-item>
	              <el-button type="primary" size="small" @click="getgoodsorbranddata">查询</el-button>
	          </el-form-item>
      	  </el-form>
	      <el-table ref="multipleTable" :data="goodsorbrandlists" v-loading="goodsorbrandLoading" @row-click="rowclick" @select="handleSelectsingle"  @select-all="handleSelectall">
		  	  <el-table-column type="selection" width="80" :selectable="selectableMethod"></el-table-column>
			  <el-table-column label="ID" width="100">
                  <template slot-scope="scope">
                      <div style="font-size:13px">{{scope.row.id}}</div>
                  </template>
              </el-table-column>
              <el-table-column label="商品信息">
                  <template slot-scope="scope">
                      <div style="float:left;width:60px;height:60px;background:rgba(221,221,221,.3);border:1px solid rgba(221,221,221,.7);border-radius:6px;display:flex;justify-content:center;align-items:center;">
                      	  <img :src="scope.row.thumb" style="max-width:85%;max-height:85%;border-radius:6px;"/>
                      </div>
                      <div style="float:left;width:calc(100% - 60px - 2px - 10px);margin-left:10px;height:60px;">
                      	<span style="float:left;width:100%;font-size:13px;line-height:21px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;">{{scope.row.name}}</span>
                      	<span style="float:left;width:100%;font-size:12px;line-height:21px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;" v-if="scope.row.spec!=''">规格：{{scope.row.spec}}</span>
                      	<span style="float:left;width:100%;font-size:12px;line-height:21px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;" v-if="scope.row.sku!='' && scope.row.sku!=null">sku：{{scope.row.sku}}</span>
                      </div>
                  </template>
              </el-table-column>
	      </el-table>
	      <div class="block">
	          <!--分页begin-->
	          <el-pagination
	            @size-change="gobpageSizeChange"
	            @current-change="gobpageCurrentChange"
	            :current-page="goodsorbrandquery.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="goodsorbrandquery.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="gob_total_rows">
	          </el-pagination>
	          <!--分页end-->
	      </div>
		  <div style="margin-top:20px;text-align:right">
      	  	  <el-button @click="goodsorbrandDialog=false" size="small">取消</el-button>
	          <el-button type="primary" :loading="gorLoading" @click="savegoodsorbrand" size="small">保存</el-button>
      	  </div>      	
	  </el-dialog>

	  <!-- 展示已选中的商品/品牌信息 -->
	  <el-dialog title="查看代金券商品/品牌" :visible.sync="showgoodsorbrandDialog" width="40%" top="5vh">
	  	  <el-table :data="showgoodsorbrandlists" v-loading="showgoodsorbrandloading">
              <el-table-column label="商品/品牌信息">
                  <template slot-scope="scope">
                      <div style="float:left;width:10%">
                      	  <i style="padding:.1rem .4rem;background:#f56c6c;border-color:#f56c6c;color:#fff;border-radius:50%;position:absolute;font-size:.1rem;font-style:normal;margin:-.6rem" v-if="scope.row.type==1">JD</i>
                      	  <i style="padding:.1rem .4rem;background:#67C23A;border-color:#67C23A;color:#fff;border-radius:50%;position:absolute;font-size:.1rem;font-style:normal;margin:-.6rem" v-if="scope.row.type==0">CZ</i>
                      	  <img :src="scope.row.thumb" style="float:left;width:100%;border:1px solid rgb(221,221,221,.7);border-radius:5px"/>
                      </div>
                      <div style="float:left;width:90%">
                      <span style="float:left;width:87%;margin-left:2%;font-size:.8rem">{{scope.row.name}}</span>
                      <span style="float:left;width:87%;margin-left:2%;color:#909399;font-size:.8rem" v-if="scope.row.spec!=''">规格：{{scope.row.spec}}</span>
                      <span style="float:left;width:87%;margin-left:2%;color:#909399;font-size:.8rem" v-if="scope.row.sku!='' && scope.row.sku!=null">sku：{{scope.row.sku}}</span>
                      </div>
                  </template>
              </el-table-column>
	      </el-table>
	  </el-dialog>

	  <!-- 展示店铺信息 -->
	  <el-dialog title="查看店铺信息" :visible.sync="shopDialog" width="70%" top="5vh">
	  	  <el-form :inline="true" size="small">
      	  	  <el-form-item>
				  <el-select v-model="shopsquery.sortype" remote  filterable placeholder="排序类型" @change="shopchange=true">	            
					  <el-option v-for="(item,index) in sorttypelists" :label="item.name" :value="item.id" :key="index"></el-option>              
              	  </el-select>  
	          </el-form-item>
			  <el-form-item>
				  <el-select v-model="shopsquery.sort" remote  filterable placeholder="排序" @change="shopchange=true">	            
					  <el-option v-for="(item,index) in sort" :label="item.name" :value="item.id" :key="index"></el-option>              
              	  </el-select>  
	          </el-form-item>
			  <el-form-item>
			  	  <el-input placeholder="请输入关键字" clearable v-model="shopsquery.key" @change="shopchange=true" @keyup.enter.native="getshopdata"></el-input>
			  </el-form-item>
	          <el-form-item>
	              <el-button type="primary" round icon="el-icon-search" @click="getshopdata">查询</el-button>
	          </el-form-item>
      	  </el-form>
	  	  <el-table :data="shoplists" v-loading="shoploading" ref="shopmultipleTable" @row-click="shoprowclick" @select="shophandleSelectsingle"  @select-all="shophandleSelectall">
			  <el-table-column type="selection" width="55"></el-table-column>
			  <el-table-column label="id" prop="id" align="center" width="100"></el-table-column>
			  <el-table-column label="店员名称" prop="truename" align="center" width="130"></el-table-column>
			  <el-table-column label="联系电话" prop="phone" align="center" width="120"></el-table-column>
              <el-table-column label="所属店铺" prop="shopname"></el-table-column>
			  <el-table-column label="采购金额" prop="reals" align="center" width="120"></el-table-column>
			  <el-table-column label="采购次数" prop="nums" align="center" width="120"></el-table-column>
			  <el-table-column label="客单价" prop="average" align="center" width="120"></el-table-column>
	      </el-table>
		  <div class="block">
	          <!--分页begin-->
	          <el-pagination
	            @size-change="shopPageSizeChange"
	            @current-change="shopCurrentChange"
	            :current-page="shopsquery.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="shopsquery.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="shop_rows">
	          </el-pagination>
	          <!--分页end-->
	      </div>
		  <div style="margin-top:20px;text-align:right">
      	  	  <el-button @click="shopDialog=false" size="small">取消</el-button>
	          <el-button type="primary" @click="saveshops" size="small">保存</el-button>
      	  </div>   
	  </el-dialog>

          
  </div>
  </transition> 
</template>

<script>
export default {
    data () {
	    return {
	        url:this.GLOBAL.domain+"Coupon/index",
	        transitionshow:true,
	        query: {
	        	act:'lists',
	        	token:this.$cookies.get('token'),
				type:'',
				couptype:'',
				discounttype:'',
				isjoin:'',
				keytype:1,
	            key:'',
	            rollpage: 10, // 页大小
	            p: 1	        	
	        },
	        create: {
	        	act:'add',
	        	token:this.$cookies.get('token'),
				oldtype:1,
				type:1,
				scollecttime:'',
				ecollecttime:'',
				starttime:'',
	        	exptime:'',
	        	name:'',
				shop_limit:'',
				expiretype:1,
				oncelimit:'',
				expireday:'',
				note:'',
	        	usecondition1:'',
				usecondition2:'',
				usecondition3:'',
	        	edu1:'',
	        	edu2:'',
	        	edu3:'',
				isjoin:0,
	        	basenum:'',
				value: 1,
				discounttype:1,
				couptype:1,
				usetype:0,
				ids:[],
				shops:[],
				idsinfo:[],
				applyproduct:[],
	        },
	        isselect:false,
	        listLoading:false,
	        total_rows:0,
	        lists:[],
	        couponDialog:false,
	        createLoading:false,
	        update: {
	        	act:'update',
	        	id:'',
	        	token:this.$cookies.get('token'),
	        	name:'',
	        	usecondition:'',
	        	edu:'',
	        	exptime:'',
	        	basenum:'',
				type:'',
				ids:[],
				applyproduct:[],
	        },
	        editcouponDialog:false,
	        updateLoading:false,
	        detail: {
	        	act:'getdetaillists',
	        	token:this.$cookies.get('token'),
	        	id:'',
	        	name:'',
	        	key:'',
	        	p:1,
	        	rollpage:10,
	        },
	        detaillists:[],
	        detailDialog:false,
	        detailisselect:false,
	        detailLoading:false,
	        detail_total_rows:0,
			//valuelists:[{id:1,name:'随机生成'},{id:2,name:'同批按顺序生成'},{id:3,name:'用户点击自动领取'}],
			valuelists:[{id:1,name:'随机生成'},{id:2,name:'同批按顺序生成'}],
			discounttypelists:[{id:1,name:'满金额减金额'},{id:2,name:'满金额打折'},{id:3,name:'满数量打折'}],
			couptypelists:[{id:1,name:'普通代金券'},{id:2,name:'指定商品代金券'},{id:3,name:'指定品牌代金券'}],
			isjoinlists:[{id:1,name:'不允许与活动叠加'},{id:2,name:'允许与活动叠加'}],
			keytypelists:[{id:1,name:'按优惠券名称查询关键字'},{id:2,name:'按优惠券码查询关键字'}],
			typelists:[{id:1,name:'搜索优惠券领取'},{id:2,name:'前端指定位置点击领取'},{id:3,name:'后台定向发放'}],
			expirelist:[{id:1,name:'指定时间内使用'},{id:2,name:'领取后指定天数内使用'}],
			usertypelists:[{id:0,name:'全部用户'},{id:1,name:'新用户'},{id:2,name:'老用户'}],
			ismoreapplylists:[],
			ismoreapplyaccess:false,
			localtype:'create',
			applytypeDialog:false,
			applytypeLoading:false,

			goodsorbranddatatype:'add',
			goodsorbrandquery: {
				act:'getmallgoodsorbrand',
				token:this.$cookies.get('token'),
				couptype:'',
				ids:[],
				goodstypelists:[],
				brandid:'',
				key:'',
				p:1,
				rollpage:10
			},		
			gob_total_rows:0,	
			goodsorbrandchange:false,
			goodsorbrandDialog:false,
			goodsorbrandLoading:false,
			goodsorbrandlists:[],
			brandlists:[],
			gorLoading:false,
			multipleTable:[],
			multipleTableinfos:[],
			showgoodsorbrandDialog:false,
			showgoodsorbrandlists:[],
			showgoodsorbrandloading:false,

			shopsquery: {
				act:'getshoplists',
				token:this.$cookies.get('token'),
				ids:[],
				key:'',
				sortype:1,
				sort:2,
				p:1,
				rollpage:10
			},
			shoploading:false,
			shopDialog:false,
			sorttypelists:[{id:1,name:'按实付金额'},{id:2,name:'按下单数量'},{id:3,name:'按客单价'}],
			sort:[{id:1,name:'升序'},{id:2,name:'降序'}],
			shoplists:[],
			shopchange:false,
			shop_rows:0,
			shoptype:'',
			shoptemp:[],
	    }  
    },
	computed: {
		userTypeList() {
			if (this.create.couptype == 3) {
				return [{id:0,name:'全部用户'},{id:1,name:'新用户'},{id:2,name:'老用户'},{id:3,name:'品牌新人'}]
			} else {
				return [{id:0,name:'全部用户'},{id:1,name:'新用户'},{id:2,name:'老用户'}]
			}
		}
	},
    mounted(){
        this.getList();
		this.getbrandList();
		this.getmoreapplyaccess(); //获取供应商多个商品权限
    },
    
    methods:{
		selectableMethod(row, index) {
			console.log("🚀 ~ selectableMethod ~ row:", row)
			// row.id等于0时设置禁选
			if (row.id == 0) {
				return false;
			}
			return true;
		},
		 /** 获取优惠券商品/品牌信息 **/
	     showgoodsorbrand(id) {
			this.showgoodsorbrandDialog=true;
			this.showgoodsorbrandloading=true;
			var resource = this.$resource(this.url);
            resource.query({act:'showcoupgoodsorbrand',token:this.$cookies.get('token'),id:id}).then((res) => {
               if(res.data.Result>0){
                   if(res.data.Result=='70001') this.$router.push('/login')
                   this.$message.error(res.data.Message);
				   this.showgoodsorbrandloading=false;
               }else{
                   this.showgoodsorbrandlists = JSON.parse(Base64.decode(res.data.Data));
				   this.showgoodsorbrandloading=false;
               }
            }).catch((res) => {
              	  this.showgoodsorbrandloading=false;
            });
		 },

		/** 点击选择商品/品牌事件 **/
	    rowclick(row,event) {
	    	var _this=this;
			var id=row.id;
			var number=-1;
			var gobnumber=-1;
			    	
			//勾选/取消勾选选中商品信息
			this.multipleTable.forEach(function(e,index) {if(id==e) number=index;});
			if(number==-1) {
				_this.multipleTable.push(id);
				_this.multipleTableinfos.push({id:id,name:row.name,thumb:row.thumb});
			}
			if(number >=0) {
				_this.multipleTable.splice(number,1);
				_this.multipleTableinfos.splice(number,1);
			}
			this.$refs.multipleTable.toggleRowSelection(row);
	    },

		/** 点击选择商品/品牌事件 **/
		handleSelectsingle(val,row) {
			var _this=this;
			var id=row.id;
			var number=-1;
			var gobnumber=-1;
    	
			//勾选/取消勾选选中商品信息
			this.multipleTable.forEach(function(e,index) {if(id==e) number=index;});
			if(number==-1) {
				_this.multipleTable.push(id);
				_this.multipleTableinfos.push({id:id,name:row.name,thumb:row.thumb});
			}
			if(number >=0) {
				_this.multipleTable.splice(number,1);
				_this.multipleTableinfos.splice(number,1);
			}
		},

		/** 商品全选/全不选 **/
		handleSelectall(val) {
			var _this=this;
			var ids=[];
			var number=-1;
			if(val.length > 0) {
				val.forEach(function(e,index) {
					number=-1;
					_this.multipleTable.forEach(function(tt,index) {if(tt==e.id) number=index;});
					if(number==-1) {
						_this.multipleTable.push(e.id);
						_this.multipleTableinfos.push({id:e.id,name:e.name,thumb:e.thumb});
					}
				});
			}else {
				this.goodsorbrandlists.forEach(function(e,index) {
					number=-1;
					_this.multipleTable.forEach(function(tt,index) {if(tt==e.id) number=index;});
					if(number >=0) {
						_this.multipleTable.splice(number,1);
						_this.multipleTableinfos.splice(number,1);
					}
				});
			}
		},

		changecouptype(type) {
			this.goodsorbrandchange=true;
			if(type=='add') {this.create.ids=[];this.create.idsinfo=[];}
			if(type=='update') {this.update.ids=[];this.update.idsinfo=[];}
		},

		//保存选中的商品/品牌信息
		savegoodsorbrand() {
			if(this.multipleTable.length==0) {this.$message.error("请选择要添加的商品或品牌");return false;}
			if(this.goodsorbranddatatype=='add') {this.create.ids=this.multipleTable;this.create.idsinfo=this.multipleTableinfos;}
			if(this.goodsorbranddatatype=='update') {this.update.ids=this.multipleTable;this.update.idsinfo=this.multipleTableinfos;}
			this.multipleTable=[];
			this.multipleTableinfos=[];
			this.goodsorbrandDialog=false;
		},

		//删除已选中的商品或品牌信息
		degoodsorbrand(type,index) {
			if(type=='add') {this.create.ids.splice(index,1);this.create.idsinfo.splice(index,1);}
			if(type=='update') {this.update.ids.splice(index,1);this.update.idsinfo.splice(index,1);}
		},

		//获取商城商品信息或品牌信息
		getgoodsorbrand(type) {
			this.goodsorbranddatatype=type;
			type=='add' ? this.goodsorbrandquery.couptype=this.create.couptype : this.goodsorbrandquery.couptype=this.update.couptype;
			this.goodsorbrandquery.ids=[];
			type=='add' ? this.goodsorbrandquery.ids=this.create.ids : this.goodsorbrandquery.ids=this.update.ids;
			this.goodsorbrandquery.goodstypelists=[];
			type=='add' ? this.goodsorbrandquery.goodstypelists=this.create.applyproduct : this.goodsorbrandquery.goodstypelists=this.update.applyproduct;
			this.goodsorbrandquery.brandid='';
			this.goodsorbrandquery.key='';
			this.multipleTable=[];
			this.getgoodsorbranddata();
		},

		getgoodsorbranddata() {
			this.goodsorbrandDialog=true;
			this.goodsorbrandLoading=true;
			if(this.goodsorbrandchange==true) {
				this.goodsorbrandquery.p=1;
				this.goodsorbrandquery.rollpage=10;
			}

			var resource = this.$resource(this.url);
            resource.query(this.goodsorbrandquery).then((res) => {
               if(res.data.Result>0){
                   if(res.data.Result=='70001') this.$router.push('/login')
                   this.$message.error(res.data.Message);
				   this.goodsorbrandLoading=false;
               }else{
                   this.goodsorbrandlists = JSON.parse(Base64.decode(res.data.Data));
				   this.gob_total_rows=parseInt(res.data.count);
				   this.goodsorbrandLoading=false;
				   if(this.goodsorbrandchange==true) this.goodsorbrandchange=false;
				   
				   var _this=this;
				   setTimeout(function() {
					   _this.goodsorbrandlists.forEach(function(e,index) {
					   	   if(_this.multipleTable.indexOf(e.id) >=0) _this.$refs.multipleTable.toggleRowSelection(e);
				   	   });
				   },100);

               }
            }).catch((res) => {
              	  this.goodsorbrandLoading=false;
            });
		},
		gobpageSizeChange(val) {
        	this.goodsorbrandquery.rollpage = val;
        	this.getgoodsorbranddata();
		},
		gobpageCurrentChange(val) {
			this.goodsorbrandquery.p = val;
			this.getgoodsorbranddata();
		},


		//获取品牌商品信息
		getbrandList() {
			var resource = this.$resource(this.GLOBAL.domain+"Brand/index");		    
			resource.query({act:'lists',token:this.$cookies.get('token'),jdshow:0,rollpage:100000}).then((res) => {
				if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
				}else{
					this.brandlists = JSON.parse(Base64.decode(res.data.Data));
				}
			}).catch((res) => {
				this.$message.error(this.GLOBAL.errortext);
			});
		},

  	   
	   //获取是否允许使用添加多个供应商权限
	   getmoreapplyaccess() {
		   var resource = this.$resource(this.GLOBAL.domain+"Setting/index");
           resource.save({ act:'getmoreapplyaccess',token:this.$cookies.get('token')}).then((res) => {
               if(res.data.Result>0){
                   if(res.data.Result=='70001') this.$router.push('/login')
                   this.$message.error(res.data.Message);
               }else{
                   var result = JSON.parse(Base64.decode(res.data.Data));
				   result.isaccessapplytype==1 ? this.ismoreapplyaccess : this.ismoreapplyaccess=true;
               }
           }).catch((res) => {
              	  
           });
	   },


  	   //获取代金券
  	   getList() {
  	   	   if(this.isselect==true) {
    		   this.query.p=1;
    		   this.query.rollpage=10;
    	   }
      
    	  this.listLoading=true;
    	  var resource = this.$resource(this.url);
          resource.query(this.query).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
                  this.listLoading=false;
              }else{
                  this.lists = JSON.parse(Base64.decode(res.data.Data));
                  this.total_rows=parseInt(res.data.count);
                  this.listLoading=false;
                  if(this.isselect==true) this.isselect=false;
              }
          }).catch((res) => {
              this.listLoading=false;
          });
  	   },
  	   
  	   queryPageSizeChange(val) {
  	   	   this.query.rollpage = val;
           this.getList();
  	   },
  	   queryPageCurrentChange(val) {
  	   	   this.query.p = val;
           this.getList();
  	   },
  	   
  	   //新增代金券
  	   addcoupon() {
  	   	   this.couponDialog=true;
	       this.create.name='';
		   this.create.type=1;
		   this.create.oldtype=1;
		   this.create.shop_limit='';
		   this.create.expiretype=1;
		   this.create.expireday='';
		   this.create.note='';
		   this.create.oncelimit='';
		   this.create.shops=[];
	       this.create.usecondition='';
	       this.create.edu='';
		   this.create.starttime='';
	       this.create.exptime='';
		   this.create.scollecttime='';
		   this.create.ecollecttime='';
	       this.create.basenum='';
		   this.create.applyproduct=[];
		   this.create.usecondition1='';
		   this.create.usecondition2='';
		   this.create.usecondition3='';
		   this.create.edu1='';
		   this.create.edu2='';
		   this.create.edu3='';
		   this.create.isjoin=0;
		   this.create.discounttype=1;
		   this.create.couptype=1;
		   this.create.usetype=0;
		   this.create.ids=[];
		   this.create.idsinfo=[];
  	   },
  	   
  	   //保存代金券信息
  	   createsave() {  
		   //if(this.create.couptype==1) {this.create.usecondition2=this.create.usecondition1;this.create.edu2=this.create.edu1;}
		   //if(this.create.couptype==2) {this.create.usecondition3=this.create.usecondition1;this.create.edu3=this.create.edu1;}
		   if((this.create.couptype==0 && this.create.usecondition1 < this.create.edu1) || (this.create.couptype==1 && this.create.usecondition2 < this.create.edu2) || (this.create.couptype==2 && this.create.usecondition3 < this.create.edu3)) {
			   this.$confirm('减少金额小于满足金额，是否继续？', '提示', { type: 'warning' }).then(() => {
					this.savecoupon();
				}).catch(() => {
					
				});  

		   }else {
			   this.savecoupon();
		   } 	   
  	   },

       savecoupon() {
		   this.createLoading=true;
  	   	   	   var resource = this.$resource(this.url);
               resource.save(this.create).then((res) => {
				  if(res.data.Result>0){
					if(res.data.Result=='70001') this.$router.push('/login')
					this.$message.error(res.data.Message);
					this.createLoading=false;
				  }else{
					this.$message.success("保存代金券信息成功！");
					this.createLoading=false;
					this.couponDialog=false;
					this.getList();
				  }
           	}).catch((res) => {
               	this.createLoading=false;
           	});  
	   },

  	   // 停用代金券
	   stopCurrent(item) {
			this.$confirm('此操作将停用该代金券, 是否继续?', '提示', { type: 'warning' }).then(() => {
              // 向请求服务端删除
              var resource = this.$resource(this.url);
              resource.save({ act:'stop_using_coupons',id: item.id,token:this.$cookies.get('token')}).then((res) => {
                  if(res.data.Result>0){
                      if(res.data.Result=='70001') this.$router.push('/login')
                      this.$message.error(res.data.Message);
                  }else{
                      this.$message.success('停用操作成功！');
                      this.getList();
                  }
              })
           })
	   },
  	   //删除代金券信息
  	   delCurrent(item) {
  	   	   this.$confirm('此操作将删除该代金券, 是否继续?', '提示', { type: 'warning' }).then(() => {
              // 向请求服务端删除
              var resource = this.$resource(this.url);
              resource.save({ act:'del',id: item.id,token:this.$cookies.get('token')}).then((res) => {
                  if(res.data.Result>0){
                      if(res.data.Result=='70001') this.$router.push('/login')
                      this.$message.error(res.data.Message);
                  }else{
                      this.$message.success('成功删除代金券');
                      this.getList();
                  }
              }).catch((res) => {
              	  
              });
           }).catch(() => {
              
           });
  	   },
  	   
  	   //编辑代金券信息
  	   editCurrent(item) {
  	   	   // 向请求服务端删除
  	   	   this.editcouponDialog=true;
           var resource = this.$resource(this.url);
           resource.save({act:'edit',id:item.id,token:this.$cookies.get('token')}).then((res) => {
               if(res.data.Result>0){
                   if(res.data.Result=='70001') this.$router.push('/login')
                   this.$message.error(res.data.Message);
               }else{
				   var result = JSON.parse(Base64.decode(res.data.Data));
				   this.update.id=result.id;
			       this.update.name=result.discribe;
			       this.update.usecondition=result.usecondition;
			       this.update.edu=result.edu;
			       this.update.exptime=result.exptime;
			       this.update.basenum=result.basenum;
				   this.update.type=result.type;
				   this.update.applyproduct=result.applyproduct;
               }
           }).catch((res) => {
              	  
           });
  	   },


	   updatesave() {		   
		   if(this.update.usecondition < this.update.edu) {
			   this.$confirm('减少金额小于满足金额，是否继续？', '提示', { type: 'warning' }).then(() => {
				   	this.updategoodssave();
				}).catch(() => {
					
				});  
		   }else {
			   this.updategoodssave();
		   } 
	   },

  	   
  	   //保存代金券信息
  	   updategoodssave() {  	   
  	   	   this.updateLoading=true;
  	   	   var resource = this.$resource(this.url);
           resource.save(this.update).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
                  this.createLoading=false;
              }else{
                  this.$message.success("保存代金券信息成功！");
                  this.updateLoading=false;
                  this.editcouponDialog=false;
                  this.getList();
              }
           }).catch((res) => {
               this.createLoading=false;
           });  	   	   
  	   },
  	   
  	   //查询代金券发放情况
  	   showorder(item) {
	       this.detail.id=item.id;
	       this.detail.name=item.discribe+'代金券列表';
	       this.detail.key='';
	       this.detail.p=1;
	       this.detail.rollpage=10;
	       this.detailDialog=true;
	       this.getdetail();
  	   },
  	   
  	   //获取代金券列表
  	   getdetail() {
  	   	   if(this.detailisselect==true) {
    		   this.detail.p=1;
    		   this.detail.rollpage=10;
    	   }
      
    	  this.detailLoading=true;
    	  var resource = this.$resource(this.url);
          resource.query(this.detail).then((res) => {
              if(res.data.Result>0){
                  if(res.data.Result=='70001') this.$router.push('/login')
                  this.$message.error(res.data.Message);
                  this.detailLoading=false;
              }else{
                  this.detaillists = JSON.parse(Base64.decode(res.data.Data));
                  this.detail_total_rows=parseInt(res.data.count);
                  this.detailLoading=false;
                  if(this.detailisselect==true) this.detailisselect=false;
              }
          }).catch((res) => {
              this.detailLoading=false;
          });
  	   },
  	   detailPageSizeChange(val) {
  	   	   this.detail.rollpage = val;
           this.getdetail();
  	   },
  	   detailPageCurrentChange(val) {
  	   	   this.detail.p = val;
           this.getdetail();
  	   },
  	   
  	   //删除代金券
  	   delDetail(item) {
  	   	   this.$confirm('此操作将删除该代金券, 是否继续?', '提示', { type: 'warning' }).then(() => {
              // 向请求服务端删除
              var resource = this.$resource(this.url);
              resource.save({ act:'deldetail',id:item.id,token:this.$cookies.get('token')}).then((res) => {
                  if(res.data.Result>0){
                      if(res.data.Result=='70001') this.$router.push('/login')
                      this.$message.error(res.data.Message);
                  }else{
                      this.$message.success('成功删除代金券');
                      this.getdetail();
                      this.getList();
                  }
              }).catch((res) => {
              	  
              });
           }).catch(() => {
              
           });
  	   },

	   //删除适用产品类型
	   delapply(index,type) {
		   if(type=='create') this.create.applyproduct.splice(index,1);
		   if(type=='update') this.update.applyproduct.splice(index,1);
	   },
  	   
  	   //获取商品类型列表
	   getapplyproducts(type) {
		   this.localtype=type;
			this.ismoreapplylists=[];
			var ids=[];
			if(type=='create') {
				this.create.applyproduct.forEach(function(item,index) {
					ids.push(item.id);
				});
			}else if(type=='update') {
				this.update.applyproduct.forEach(function(item,index) {
					ids.push(item.id);
				});
			}
			
			this.applytypeDialog=true;
			this.applytypeLoading=true;
			var resource = this.$resource(this.url);
            resource.save({ act:'getapplytype',ids:ids,token:this.$cookies.get('token')}).then((res) => {
                 if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login')
                    this.$message.error(res.data.Message);
					this.applytypeLoading=false;
                 }else{
                    this.ismoreapplylists = JSON.parse(Base64.decode(res.data.Data));
					this.applytypeLoading=false;
                 }
            }).catch((res) => {
              	this.applytypeLoading=false;
            });
	   },


	   //选择供应商信息
	   selectapply(item) {
		   if(this.localtype=='create') {this.create.applyproduct.push({id:item.id,name:item.name});}
		   if(this.localtype=='update') {this.update.applyproduct.push({id:item.id,name:item.name});}
		   this.applytypeDialog=false;
	   },


	  /** 获取店铺信息 **/
      getshops(type) {
		  this.shopsquery.ids=[];
		  this.shopsquery.key='';
		  this.shopsquery.sortype=1;
		  this.shopsquery.sort=2;
		  this.shopDialog=true;
		  this.shoptype='add';
		  this.shoptemp=[];
		  this.getshopdata(type);
	  },

	  //获取店铺信息列表
	  getshopdata() {
		  var shopids=[];
		  if(this.shoptype=='add') {
			  this.create.shops.forEach(function(e,i) {shopids.push(e.id);});
		  }else {
			  this.update.shops.forEach(function(e,i) {shopids.push(e.id);});
		  }
		  if(this.shopchange) {
			  this.shopsquery.p=1;
			  this.shopsquery.rollpage=10;
		  }
		  this.shopsquery.ids=shopids;
		  this.shoploading=true;
		  var resource = this.$resource(this.url);
          resource.save(this.shopsquery).then((res) => {
                 if(res.data.Result>0){
                    if(res.data.Result=='70001') this.$router.push('/login')
                    this.$message.error(res.data.Message);
					this.shoploading=false;
                 }else{
                    this.shoplists = JSON.parse(Base64.decode(res.data.Data));
					this.shop_rows=parseInt(res.data.count);
					this.shoploading=false;
					if(this.shopchange) this.shopchange=false;

					var ids=[];
					var _this=this;
					this.shoptemp.forEach(function(e,index) {ids.push(e.id);});
					setTimeout(function() {
						_this.shoplists.forEach(function(e,index) {
							if(ids.indexOf(e.id) >= 0) _this.$refs.shopmultipleTable.toggleRowSelection(e);
						});
					},200);
					
                 }
          }).catch((res) => {
              	this.shoploading=false;
          });
	  },

	  shopPageSizeChange(val) {
  	   	   this.shopsquery.rollpage = val;
           this.getshopdata();
  	   },
  	   shopCurrentChange(val) {
  	   	   this.shopsquery.p = val;
           this.getshopdata();
  	   },


	   	/** 单行点击 **/
	    shoprowclick(row,event) {
	    	var _this=this;
			var ids=[];
			this.shoptemp.forEach(function(e,index) {ids.push(e.id)});
			if(ids.indexOf(row.id)==-1) {
				this.shoptemp.push({id:row.id,username:row.truename,shopname:row.shopname});
			}else {
				this.$delete(this.shoptemp,ids.indexOf(row.id));
			} 
			this.$refs.shopmultipleTable.toggleRowSelection(row);
	    },

		/** 直接点击勾选/取消勾选 **/
		shophandleSelectsingle(val,row) {
			var _this=this;
			var ids=[];
			this.shoptemp.forEach(function(e,index) {ids.push(e.id)});
			if(ids.indexOf(row.id)==-1) {
				this.shoptemp.push({id:row.id,username:row.truename,shopname:row.shopname});
			}else {
				this.$delete(this.shoptemp,ids.indexOf(row.id));
			} 
		},

		/** 点击全选/全不选 **/
		shophandleSelectall(val) {
			var _this=this;
			if(val.length >0) { //全选
				var ids=[];
				this.shoptemp.forEach(function(e,i) {ids.push(e.id)});
				val.forEach(function(e,i) {
					ids.indexOf(e.id)==-1 ? _this.shoptemp.push({id:e.id,username:e.truename,shopname:e.shopname}) : ''; 
				});

			}else { //全不选
				var number=-1;
				this.shoplists.forEach(function(item,index) {
					number=-1;
					_this.shoptemp.forEach(function(t,i) {if(item.id==t.id) number=i;});
					number >=0 ? _this.$delete(_this.shoptemp,number) : '';
				});
			}
		},

		/** 保存选中的店铺信息 **/
		saveshops() {
			if(this.shoptemp.length==0) {this.$message.error("请至少选择一个店铺");return false;}
			var ids=[];
			var _this=this;
			if(this.shoptype=='add') {
				this.create.shops.forEach(function(e,i) {ids.push(e.id);});
				this.shoptemp.forEach(function(item,index) {
					ids.indexOf(item.id)==-1 ? _this.create.shops.push({id:item.id,username:item.username,shopname:item.shopname,num:1}) : '';
				});
			}else {
				this.update.shops.forEach(function(e,i) {ids.push(e.id);});
				this.shoptemp.forEach(function(item,index) {
					ids.indexOf(item.id)==-1 ? _this.update.shops.push({id:item.id,username:item.username,shopname:item.shopname,num:1}) : '';
				});
			}
			this.shopDialog=false;
		},

		/** 删除已添加的店铺信息 **/
		deshops(type,index) {
			if(type=='add') this.$delete(this.create.shops,index);
			if(type=='update') this.$delete(this.create.shops,index);
		},


		/** 修改优惠券的发放方式 **/
		changecouptype(type) {
			this.$confirm('切换优惠券发放方式会调整部分数据, 是否继续?', '提示', { type: 'warning' }).then(() => {
				if(type=='add' && this.create.type==1) { //搜索领取优惠券
					this.create.basenum=''; //发放数量
					this.create.shop_limit=''; //每店限制领取数量
					this.create.oncelimit=''; //单次点击领取数量
					this.create.starttime=''; //开始时间
					this.create.exptime=''; //结束时间
					this.create.expireday=''; //天数
					this.create.expiretype=1; //有效期时间类型
					this.create.shops=[];
				}else if(type=='add' && this.create.type==2) { //点击领取优惠券
					this.create.value=1; //编码规则
					this.create.basenum=''; //发放数量
					this.create.shop_limit=''; //每店限制领取数量
					this.create.oncelimit=''; //单次点击领取数量
					this.create.scollecttime=''; //领取开始时间
					this.create.ecollecttime=''; //领取结束时间
					this.create.starttime=''; //开始时间
					this.create.exptime=''; //结束时间
					this.create.expireday=''; //天数
					this.create.expiretype=1;
					this.create.usetype=0; //领取人群
					this.create.shops=[];
				}else if(type=='add' && this.create.type==3) { //后台自动发放优惠券
					this.create.value=1; //编码规则
					this.create.basenum=''; //发放数量
					this.create.shop_limit=''; //每店限制领取数量
					this.create.oncelimit=''; //单次点击领取数量
					this.create.expiretype=1; //有效期类型
					this.create.starttime=''; //开始时间
					this.create.exptime=''; //结束时间
					this.create.expireday=''; //天数
				}else if(type=='update' && this.update.type==1) { //搜索领取优惠券
					this.update.basenum=''; //发放数量
					this.update.shop_limit=''; //每店限制领取数量
					this.update.oncelimit=''; //单次点击领取数量
					this.update.starttime=''; //开始时间
					this.update.exptime=''; //结束时间
					this.update.expireday=''; //天数
					this.update.expiretype=1; //有效期时间类型
					this.update.shops=[];
				}else if(type=='update' && this.update.type==2) { //点击领取优惠券
					this.update.value=1; //编码规则
					this.update.basenum=''; //发放数量
					this.update.shop_limit=''; //每店限制领取数量
					this.update.oncelimit=''; //单次点击领取数量
					this.update.scollecttime=''; //领取开始时间
					this.update.ecollecttime=''; //领取结束时间
					this.update.starttime=''; //开始时间
					this.update.exptime=''; //结束时间
					this.update.expireday=''; //天数
					this.update.expiretype=1;
					this.update.usetype=0; //领取人群
					this.update.shops=[];
				}else if(type=='update' && this.update.type==3) { //后台自动发放优惠券
					this.update.value=1; //编码规则
					this.update.basenum=''; //发放数量
					this.update.shop_limit=''; //每店限制领取数量
					this.update.oncelimit=''; //单次点击领取数量
					this.update.expiretype=1; //有效期类型
					this.update.starttime=''; //开始时间
					this.update.exptime=''; //结束时间
					this.update.expireday=''; //天数
				}

				type=='add' ? this.create.oldtype=this.create.type : this.update.oldtype=this.update.type;
			}).catch(() => {
				type=='add' ? this.create.type=this.create.oldtype : this.update.type=this.update.oldtype;
			});
		},

		/** 获取代金券详情 **/
		showcoupondetail(item) {
			this.$emit('listenchild',{name:item.discribe+'代金券详情',url:'Coupondetail',data:item});
		},

    }
}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.coupercent .el-form-item__content {width:60%}
.coupradio .el-radio__input.is-checked .el-radio__inner {background:#E6A23C;border-color:#E6A23C}
.coupradio .el-radio__input.is-checked+.el-radio__label {color:#E6A23C}
.coupradio .el-radio__inner:hover {border-color:#E6A23C}
</style>


// WEBPACK FOOTER //
// src/components/mall/Coupon.vue